export default "__VITE_ASSET__2tvdbEnF__"